//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"Method",1,0]],[[["sortingData"],"SetSortingData",{},1,0],[["numSortData"],"GetSortingData",{R_:{sortingData:""}},0,0],[["numRows"],"GetManualSortRowList",{R_:{rowList:""}},0,0],[["rowList"],"SetManualSortRowList",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.TableCommonSortingBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TableCommonSortingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.TableCommonSortingBuilder.SortData = class{
    constructor(columnPosition,sortingDirection){
        this.columnPosition=columnPosition;this.sortingDirection=sortingDirection;}
    get Columnposition(){return this.columnPosition}
    set Columnposition(val){this.columnPosition = val}
    get Sortingdirection(){return this.sortingDirection}
    set Sortingdirection(val){this.sortingDirection = val}
};

SPLM.Annotations.TableCommonSortingBuilder.MethodType = Object.freeze({
    "Alphabetic" : "Alphabetic", "Alphanumeric" : "Alphanumeric", "Manual" : "Manual"});

SPLM.Annotations.TableCommonSortingBuilder.SortingDirection = Object.freeze({
    "Descending" : "Descending", "Ascending" : "Ascending"});

export default SPLM;